module.exports = __webpack_public_path__ + "91d194bfb56e1768bb955b5f3b30b5b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room1/audio1/Meditation for Suburb Brain.jpg
// module id = 891
// module chunks = 0